export default "__VITE_ASSET__e55dda66__"